import { useState } from "react";
import ShadowContainer from "../../../components/common/ShadowContainer";

const inputClass =
  "w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm text-black placeholder-gray-400 focus:outline-none focus:border-black focus:bg-white transition-all duration-200";

const UserForm = ({ form, errors, handleFormChange, handleRoleChange, handleSubmit }) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <ShadowContainer maxWidth="max-w-full" padding="p-0">
      {/* Header — always visible */}
      <button
        type="button"
        onClick={() => setExpanded((prev) => !prev)}
        className="w-full flex items-center justify-between gap-2 px-6 py-4 hover:bg-gray-50 transition-colors rounded-xl"
      >
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-black flex items-center justify-center text-white flex-shrink-0">
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">New User Details</h3>
        </div>
        <svg
          className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${expanded ? "rotate-180" : "rotate-0"}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Collapsible body */}
      {expanded && (
        <div className="px-6 pb-6 border-t border-gray-100">
          <form onSubmit={handleSubmit} className="pt-5">
            {/* Role toggle */}
            <div className="flex items-center gap-2 mb-5">
              <span className="text-xs font-semibold text-gray-500 uppercase tracking-widest mr-2">Role</span>
              {["admin", "waiter"].map((role) => (
                <button
                  key={role}
                  type="button"
                  onClick={() => handleRoleChange(role)}
                  className={`px-4 py-1.5 rounded-full text-sm font-semibold border transition-all duration-200 ${
                    form.role === role
                      ? "bg-black text-white border-black"
                      : "bg-white text-gray-500 border-gray-200 hover:border-gray-400"
                  }`}
                >
                  {role.charAt(0).toUpperCase() + role.slice(1)}
                </button>
              ))}
            </div>

            {/* Fields */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              <div>
                <input
                  name="firstName"
                  value={form.firstName}
                  onChange={handleFormChange}
                  placeholder="First Name"
                  className={`${inputClass} ${errors.firstName ? "border-red-400 focus:border-red-400" : ""}`}
                />
                {errors.firstName && <p className="mt-1 text-xs text-red-500">{errors.firstName}</p>}
              </div>

              <div>
                <input
                  name="lastName"
                  value={form.lastName}
                  onChange={handleFormChange}
                  placeholder="Last Name"
                  className={`${inputClass} ${errors.lastName ? "border-red-400 focus:border-red-400" : ""}`}
                />
                {errors.lastName && <p className="mt-1 text-xs text-red-500">{errors.lastName}</p>}
              </div>

              <div>
                <input
                  name="userName"
                  value={form.userName}
                  onChange={handleFormChange}
                  placeholder="Username"
                  className={`${inputClass} ${errors.userName ? "border-red-400 focus:border-red-400" : ""}`}
                />
                {errors.userName && <p className="mt-1 text-xs text-red-500">{errors.userName}</p>}
              </div>

              <button
                type="submit"
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-xl text-sm font-semibold active:scale-[0.98] transition-all duration-200 flex items-center justify-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Save User
              </button>
            </div>
          </form>
        </div>
      )}
    </ShadowContainer>
  );
};

export default UserForm;
